// extracted by mini-css-extract-plugin
module.exports = {"root":"app-button-module_root_1EL44"};